import { getSitesWithAdminClaim } from 'utils/accessHelpers'
import { paths } from './paths'

export const getLUMDefaultPath = ({
  isLicenseAdmin,
  isSiteAdmin,
  sites = [],
}) => {
  if (isLicenseAdmin) {
    return paths.UNASSIGNED_LICENSES
  }

  if (isSiteAdmin) {
    const firstSiteId = getSitesWithAdminClaim(sites)[0]?.id
    return firstSiteId != null
      ? `/user-management/${firstSiteId}`
      : paths.USER_MANAGEMENT.replace('/:siteId?', '')
  }

  return null
}
